import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import Select from 'react-select';





const Profile = () => {
    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    const [occupations, setOccupations] = useState(null);
    const [states, setStates] = useState(null);

    useEffect(() => {

        document.title = 'Roam Pays: Your Profile';

        getUser();
        getOccupations();
        getStates();



    }, []);


    const getUser = async (e) => {

        axios.get(process.env.REACT_APP_API_URL + "/get-user", {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
            .then(function (response) {
                if (response?.data?.status) {


                    setUser(response?.data?.user);
                    localStorage.setItem('@roampays-user', JSON.stringify(response.data.user))


                }
                else {
                    navigate("/login")
                }
            })
            .catch(function (error) {
                if (error.status == 403) navigate("/login")
                else
                    Swal.fire({ icon: "error", title: "Error", text: error.message });

            });


    }

    const getOccupations = async (e) => {
        axios.get(process.env.REACT_APP_API_URL + "/get-occupations", {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
            .then(function (response) {
                if (response?.data?.status) {

                    setOccupations(response?.data?.occupations);

                }
            })
            .catch(function (error) {
                if (error.status == 403) navigate("/login")
                else
                    Swal.fire({ icon: "error", title: "Error", text: error.message });

            });


    }


    const getStates = async (e) => {
        axios.get(process.env.REACT_APP_API_URL + "/get-states", {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
            .then(function (response) {
                if (response?.data?.status) {


                    setStates(response?.data?.states);



                }
            })
            .catch(function (error) {
                if (error.status == 403) navigate("/login")
                else
                    Swal.fire({ icon: "error", title: "Error", text: error.message });

            });


    }


    const goToNotifications = async (e) => {
        navigate("/notifications");
    }

    const goToName = async (e) => {
        navigate("/profile/name");
    }
    const goToFilingStatus = async (e) => {
        navigate("/profile/filing-status")
    }
    const goToNoOfDependents = async (e) => {
        navigate("/profile/no-of-dependents")
    }

    const goToEmail = async (e) => {
        navigate("/profile/email")
    }
    const goToPrivacyPolicy = async (e) => {
        navigate("/profile/privacy-policy")
    }
    const goToTermsAndConditions = async (e) => {
        navigate("/profile/terms-and-conditions")
    }
    const goToFeedback = async (e) => {
        navigate("/profile/feedback")
    }
    const goToDeleteAccount = async (e) => {

        navigate("/profile/remove-account")

    };

    const saveOccupation = async (e) => {


        const occupation_id = e.value;

        if (occupation_id && occupation_id > 0) {

            await axios.post(process.env.REACT_APP_API_URL + "/save-occupation", {
                occupation_id: occupation_id,
            }, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            })
                .then(function (response) {
                    if (response?.data?.status) {

                        getUser();
                    }
                    else {

                        Swal.fire({ icon: "error", title: "Error", text: "Occupation cannot be saved due to technical problem, please try later." });

                    }
                })
                .catch(function (error) {
                    if (error.status == 403) navigate("/login")
                    else
                        Swal.fire({ icon: "error", title: "Error", text: error.message });

                });

        }
    };


    const saveState = async (e) => {


        const state_id = e.value;

        if (state_id && state_id > 0) {

            await axios.post(process.env.REACT_APP_API_URL + "/save-state", {
                state_id: state_id,
            }, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            })
                .then(function (response) {
                    if (response?.data?.status) {

                        getUser();
                    }
                    else {

                        Swal.fire({ icon: "error", title: "Error", text: "Occupation cannot be saved due to technical problem, please try later." });

                    }
                })
                .catch(function (error) {

                    Swal.fire({ icon: "error", title: "Error", text: error.message });

                });

        }
    };


    const cancelSubscription = async () => {

        const result = await Swal.fire({
            title: 'Cancel Subscription?',
            text: 'Your subscription will be suspended.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Cancel',
            cancelButtonText: 'No'
        });

        if (!result.isConfirmed) return;

        axios.post(process.env.REACT_APP_API_URL + "/suspend-subscription", {}, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
            .then(function (response) {

                if (response?.data?.status) {


                    // 1. Fetch current cached user data from localStorage
                    const storedUser = localStorage.getItem('@roampays-user');
                    if (storedUser) {
                        const parsedUser = JSON.parse(storedUser);

                        // 2. Clear out the active subscription fields in memory
                        const updatedUser = {
                            ...parsedUser,
                            stripe_package: null,
                            stripe_subscription_id: null,
                        };

                        // 3. Commit the downgraded user back to localStorage
                        localStorage.setItem('@roampays-user', JSON.stringify(updatedUser));

                        // 4. Notify reactive tracking wrappers immediately
                        window.dispatchEvent(new Event('user-subscribed'));
                    }
                    Swal.fire({
                        icon: "success",
                        title: "Success",
                        text: "Subscription cancelled successfully."
                    });

                    getUser();

                } else {

                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: "Subscription could not be cancelled."
                    });

                }

            })
            .catch(function (error) {

                if (error.status == 403)
                    navigate("/login");
                else
                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: error.message
                    });

            });

    };

    const logout = async () => {

        axios.post(
            process.env.REACT_APP_API_URL + "/logout",
            {},
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }
        )
            .then(function () {

                localStorage.removeItem('@roampays-user');

                navigate("/login");

            })
            .catch(function (error) {

                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: error.message
                });

            });

    };
    return (


        <>


            <div className="title-box">
                <div className="flex-equal" ></div>
                <h3 className="flex-equal justify-content-center fs-32 fs-helvetica color-white lg">Profile</h3>
                <div className="flex-equal justify-content-end" >
                    <div className="icon" onClick={goToNotifications}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.91667 7.24097V5.83268C10.3315 5.83268 10.7261 5.74609 11.0833 5.58999V6.75772L12.25 7.92439V11.0827H9.33333C9.33333 11.2363 9.31817 11.39 9.28776 11.5416C9.21737 11.8925 9.0672 12.2225 8.84886 12.5061C8.63052 12.7897 8.34987 13.0193 8.02862 13.1771C7.70738 13.3348 7.35414 13.4166 6.99623 13.416C6.63833 13.4154 6.28535 13.3325 5.96461 13.1737C5.64388 13.0149 5.36397 12.7844 5.14655 12.5001C4.92913 12.2158 4.78003 11.8853 4.71077 11.5342C4.68134 11.385 4.66667 11.2338 4.66667 11.0827H1.75V7.92439L2.91667 6.75772V5.24935C2.91667 2.99419 4.74484 1.16602 7 1.16602C7.1884 1.16602 7.37382 1.17877 7.55545 1.20348C7.31503 1.53439 7.14248 1.91779 7.05823 2.33325C7.03886 2.33287 7.01945 2.33268 7 2.33268C5.38917 2.33268 4.08333 3.63852 4.08333 5.24935V7.24097L2.91667 8.40764V9.91602H11.0833V8.40764L9.91667 7.24097ZM5.83333 11.0827C5.83333 11.1582 5.84067 11.2338 5.85538 11.3084C5.89001 11.484 5.96457 11.6493 6.07328 11.7914C6.18198 11.9336 6.32194 12.0488 6.48231 12.1282C6.64268 12.2076 6.81916 12.2491 6.99812 12.2494C7.17707 12.2496 7.35369 12.2088 7.51431 12.1299C7.67494 12.051 7.81526 11.9362 7.92443 11.7944C8.0336 11.6526 8.10868 11.4876 8.14388 11.3121C8.15908 11.2364 8.16667 11.1595 8.16667 11.0827H5.83333Z" fill="white" />
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.16667 2.91602C8.16667 1.94952 8.95017 1.16602 9.91667 1.16602C10.8832 1.16602 11.6667 1.94952 11.6667 2.91602C11.6667 3.88251 10.8832 4.66602 9.91667 4.66602C8.95017 4.66602 8.16667 3.88251 8.16667 2.91602ZM9.91667 2.33268C9.5945 2.33268 9.33333 2.59385 9.33333 2.91602C9.33333 3.23818 9.5945 3.49935 9.91667 3.49935C10.2388 3.49935 10.5 3.23818 10.5 2.91602C10.5 2.59385 10.2388 2.33268 9.91667 2.33268Z" fill="white" />
                        </svg>
                    </div>
                </div>

            </div>

            <div className="box" >

                <div className="card" >

                    <div className="card-title" >

                        <label className="color-white fs-18" >Your Info</label>

                    </div>

                    <div className="card-content" >

                        <div className="input-container" >
                            <label >Name</label>

                            <div className="input-box" onClick={goToName} >

                                <label className="color-light fs-14 flex-grow-1"  >{user?.first_name} {user?.last_name}</label>
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.674 9.0008L6.83691 5.16372L8.16274 3.83789L13.3257 9.0008L8.16274 14.1637L6.83691 12.8379L10.674 9.0008Z" fill="white" />
                                </svg>
                            </div>


                        </div>
                        <div className="input-container" >
                            <label >I'm a...</label>

                            <Select
                                className="react-select" classNamePrefix="react-select"
                                defaultValue={{ "value": 3, "label": "Graphic Designer" }}
                                options={occupations}
                                value={{ "value": user?.occupation_id, "label": user?.occupation_name }}

                                onChange={(y) => { saveOccupation(y) }}
                                noOptionsMessage={({ inputValue }) => !inputValue ? "Start Typing" : "No results found"}
                            />

                        </div>

                        <div className="input-container">
                            <label>Subscription Plan</label>

                            <div className="input-box d-flex align-items-center">

                                <label className="color-light fs-14 flex-grow-1">
                                    {user?.package_title}
                                </label>

                                {
                                    user?.stripe_package != null && (
                                        <button
                                            type="button"
                                            className="btn btn-danger btn-sm"
                                            onClick={cancelSubscription}
                                        >
                                            Cancel Subscription
                                        </button>
                                    )
                                }

                            </div>
                        </div>





                    </div>

                </div>


                <div className="card" >

                    <div className="card-title" >

                        <div className="box-title color-white fs-18 fs-helvetica" >

                            Taxes

                        </div>



                    </div>

                    <div className="card-content" >

                        <div className="input-container" >
                            <label >State of Residence</label>

                            <Select
                                className="react-select" classNamePrefix="react-select"
                                cacheOptions
                                options={states}
                                placeholder=""
                                value={{ "value": user?.state_id, "label": user?.state_name }}
                                onChange={(y) => { saveState(y) }}
                                noOptionsMessage={({ inputValue }) => !inputValue ? "Start Typing" : "No results found"}
                            />


                        </div>

                        <div className="input-container" >
                            <label >Filing Status</label>

                            <div className="input-box" onClick={goToFilingStatus} >

                                <label className="color-light fs-14 flex-grow-1"  >{user?.filing_status_name}</label>
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.674 9.0008L6.83691 5.16372L8.16274 3.83789L13.3257 9.0008L8.16274 14.1637L6.83691 12.8379L10.674 9.0008Z" fill="white" />
                                </svg>
                            </div>


                        </div>

                        <div className="input-container" >
                            <label >Number of Dependents</label>

                            <div className="input-box" onClick={goToNoOfDependents} >

                                <label className="color-light fs-14 flex-grow-1"  >{user?.no_of_dependents}</label>
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.674 9.0008L6.83691 5.16372L8.16274 3.83789L13.3257 9.0008L8.16274 14.1637L6.83691 12.8379L10.674 9.0008Z" fill="white" />
                                </svg>
                            </div>


                        </div>

                    </div>

                </div>





                <div className="card" >

                    <div className="card-title" >

                        <div className="box-title color-white fs-18 fs-helvetica" >Sign-In & Security</div>



                    </div>

                    <div className="card-content" >

                        <div className="input-container" >
                            <label>Email</label>
                            <div className="input-box" onClick={goToEmail} >

                                <label className="color-light fs-14 flex-grow-1"  >{user?.email}</label>
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.674 9.0008L6.83691 5.16372L8.16274 3.83789L13.3257 9.0008L8.16274 14.1637L6.83691 12.8379L10.674 9.0008Z" fill="white" />
                                </svg>
                            </div>


                        </div>



                    </div>

                </div>


                <div className="card mb-32" >

                    <div className="card-title" >

                        <div className="box-title color-white fs-18 fs-helvetica" >App</div>



                    </div>

                    <div className="card-content g-14" >

                        <div className="input-container" onClick={goToPrivacyPolicy}  >
                            <div class="input-box bg-transparent">
                                <label className="color-light fs-16  bg-transparent flex-grow-1">Privacy Policy</label>
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.674 9.0008L6.83691 5.16372L8.16274 3.83789L13.3257 9.0008L8.16274 14.1637L6.83691 12.8379L10.674 9.0008Z" fill="white" />
                                </svg>
                            </div>

                        </div>

                        <div className="input-container bg-transparent" onClick={goToTermsAndConditions}  >
                            <div class="input-box bg-transparent">
                                <label class="color-light fs-16  bg-transparent  flex-grow-1">Terms & Conditions</label>
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.674 9.0008L6.83691 5.16372L8.16274 3.83789L13.3257 9.0008L8.16274 14.1637L6.83691 12.8379L10.674 9.0008Z" fill="white"></path></svg>
                            </div>


                        </div>

                        <div className="input-container bg-transparent" onClick={goToFeedback}  >
                            <div class="input-box bg-transparent">
                                <label className="color-light fs-16  bg-transparent  flex-grow-1">Feedback</label>
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.674 9.0008L6.83691 5.16372L8.16274 3.83789L13.3257 9.0008L8.16274 14.1637L6.83691 12.8379L10.674 9.0008Z" fill="white"></path></svg>
                            </div>


                        </div>
                        <div className="input-container bg-transparent" onClick={goToDeleteAccount}  >
                            <div class="input-box bg-transparent">
                                <label className="color-light fs-16  bg-transparent  flex-grow-1">Delete Account</label>
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.674 9.0008L6.83691 5.16372L8.16274 3.83789L13.3257 9.0008L8.16274 14.1637L6.83691 12.8379L10.674 9.0008Z" fill="white"></path></svg>
                            </div>


                        </div>

                        <div
                            className="input-container bg-transparent"
                            onClick={logout}
                        >

                            <div className="input-box bg-transparent">

                                <label className="color-light fs-16 bg-transparent flex-grow-1">
                                    Logout
                                </label>

                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M10.674 9.0008L6.83691 5.16372L8.16274 3.83789L13.3257 9.0008L8.16274 14.1637L6.83691 12.8379L10.674 9.0008Z"
                                        fill="white"
                                    />
                                </svg>

                            </div>

                        </div>



                    </div>

                </div>


            </div>





        </>


    );
};

export default Profile;